export const locale = {
  lang: "ar",
  data: {
    MENU: {
      DASHBOARD: {
        chatView: "شات",
        supportChat: "دعم",
        COLLAPSIBLE: "لوحة التحكم",
        BADGE: "2",
        ANALYTICS: "الإحصائيات",
        ECOMMERCE: "التجارة الإلكترونية",
        SUBCATEGORY: "القسم الفرعي",
        SELECT_SUBCATEGORY: "اختر القسم الفرعي",
        BOOK_TYPE: "نوع الكتاب",
        CATEGORYy: " القسم",
        ADD_BOOK: "إضافة كتاب",
        FILL_BOOK_DETAILS: "املأ تفاصيل الكتاب",
        SELECT_CATEGORY: "اختر القسم",
        SELECT_BOOK_TYPE: "اختر نوع الكتاب",
        PRINTED_BOOK: "كتاب ورقي",
        AUDIO_BOOK: "كتاب سمعي",
        ASK_BOOKS_LIST: "قائمة طلبات الكتب",
        ASK_BOOKS: "طلبات الكتب",
        NO_FILE_SELECTED: "لم يتم اختيار ملف",
        id: "الرقم التعريفي",
        sendNotification: "ارسال تنبيه",
        openscreenlist: "قائمة الشاشات البداية",
        LOGOUT: "تسجيل الخروج",
        REAL: "مستخدم حقيقي",
        FAKE: "مستخدم وهمي",
        USER_NAME: "اسم المستخدم",
        AUTHOR: "المؤلف",
        STATUS: "الحالة",

        CANCEL: "إلغاء",
        CONFIRM_DELETE_TITLE: "هل أنت متأكد؟",
        CONFIRM_DELETE_TEXT: "سيتم حذف الكتاب بشكل نهائي.",
        YES_DELETE: "نعم، احذفه!",
        DELETED_TITLE: "تم الحذف!",
        TITLEE: "هل أنت متأكد؟",
        TEXT: "سيتم حذف الكتاب بشكل نهائي.",
        CONFIRM: "نعم، احذفه!",
        UPLOAD_IMAGE: "تحميل الصورة",
        reports: "التقارير",
        contests: "المسابقات",
        stories: "القصص",
        CONTENT: "المحتوى", 
        writers: "الكتّاب",
        BOOK_ID: "معرف الكتاب",
        REPORTS_COUNT: "عدد البلاغات",
        NAME_AR: "الاسم بالعربية",
        NAME_EN: "الاسم بالإنجليزية",
        BODY_AR: "النص باللغة العربية",
        BODY_EN: "النص باللغة الإنجليزية",
        LAST_LOGGED_TIME: "آخر وقت تسجيل دخول",
        DELETED_TEXT: "تم حذف الكتاب.",
        ADD_OPEN_SCREEN: "إضافة شاشة ترحيب",
        ERROR_TITLE: "خطأ!",
        ERROR_TEXT: "حدث خطأ ما.",
        OK: "حسنًا",
        ERROR: "خطأ",
        SELECT_IMAGE: "يرجى اختيار صورة.",
        USER_SAVED: "تم حفظ المستخدم بنجاح",
        FIX_ERRORS: "يرجى تصحيح الأخطاء والمحاولة مرة أخرى.",
        rememberMe: "تذكرني",
        welcomeMsg: "مرحبا بك في",
        incorrectInfo: "البريد الالكتروني او كلمة المرور غير صحيحة",
        acceptanceMsg: "هل تريد حذف هذا الكتاب؟",
        loading: "جاري التحميل...",
        image: "الصورة",
        books: "الكتب",
        profile: "الملف الشخصي",
        Main_Category: "الفئة الرئيسية ",
        Subcategory_Name: " اسم الفئة الفرعية   ",
        closeAcc: "اغلاق الحساب",
        followers: "المتابعين",
        FIELD_REQUIRED: "هذا الحقل مطلوب",
        POSITIVE_NUMBER: "يجب أن يكون رقمًا موجبًا",
        WELCOME_MESSAGE: "", 
        following: "المتابعون",
        changeLanguage: "تغيير اللغة",

        WELCOME_MESSAGEE:
          "             منصة مكتبتي تتيح لك قراءة الروايات والقصص، ونشر كتاباتك بكل سهولة. انضم لآلاف الكتّاب والقرّاء في عالم من الإبداع والتفاعل  ",
        WELCOME_MESSAGEEE:
          "             الكلمات المفتاحية: مكتبتي, كتب, روايات, قصص, كتابة, قراءة, منصة أدبية, كتّاب, قرّاء   ",
        ADD_SUBCATEGORY: "إضافة فئة فرعية",
        maktabity: "مكتبتي",
        signInMessage: "يرجى تسجيل الدخول لحسابك وبدء التحديث",
        email: "البريد الالكتروني",
        password: "كلمة المرور",
        forgetPassword: "نسيت كلمة المرور؟",
        signIn: "تسجيل الدخول",
        next: "التالي",
        prev: "السابق",
        addSubCategory: "إضافة فئة فرعية",
        subCategoryName: "اسم الفئة الفرعية",
        subCategoryId: "معرف الفئة الفرعية",
        editSubCategory: "تعديل الفئة الفرعية",
        TOTAL_USERS: "إجمالي عدد المستخدمين",
        BOOKS_COUNT: "عدد الكتب",
        MAIN_CATEGORIES: "الفئات الرئيسية",
        MAIN_CATEGORIES_LIST: "قائمة الفئات الرئيسية",
        ADD_CATEGORY: "إضافة فئة",
        CATEGORY_NAME: "اسم الفئة",
        BOOKS: "الكتب",
        BOOKS_LIST: "قائمة الكتب",
        BOOK_DESCRIPTION: "وصف الكتاب",
        BOOK_NAME: "اسم الكتاب",
        CATEGORY: "الفئة",
        SUB_CATEGORY: "الفئة الفرعية",
        EXP: "الخبرة", // or use appropriate meaning for "exp"
        EDIT: "تعديل",
        EDITS: "تعديل روابط",
        CLICK: " البريد الإلكتروني",
        CLICK_LIST: "قائمة البريد الإلكتروني",
        CAMPAIGN: "الحملة",
        CLICKED_AT: "تم النقر في",
        USER_AGENT: "عامل المستخدم",
        DATE: "التاريخ",
        ENTER_TITLE: "أدخل عنوان الإشعار",
        ENTER_BODY: "أدخل محتوى الإشعار",
        SEND: "إرسال الإشعار",
        REPORTS: "التقارير",
        REPORTS_LIST: "قائمة التقارير",
        FAKE_USERS: "مستخدمون وهميون",
        FAKE_USERS_LIST: "قائمة المستخدمين الوهميين",
        NAME: "الاسم",
        DATE_OF_BIRTH: "تاريخ الميلاد",
        EMAIL: "البريد الإلكتروني",
        MOBILE: "رقم الجوال",
        GENDER: "الجنس",
        FOLLOWERS: "المتابعين",
        FOLLOWING: "المتابَعون",
        SUCCESS: "نجاح",
        BOOK_ADDED: "تمت إضافة الكتاب بنجاح",
        MALE: "ذكر",
        FEMALE: "أنثى",
        NOT_SPECIFIED: "غير محدد",
        ARTICLES: "المقالات",
        SAVE: "حفظ",
        DAILY_USERS: "المستخدمين اليوميون",
        DAILY_USERS_LIST: "قائمة المستخدمين اليوميين",
        TODAY_REGISTERED_USERS: "مسجلين جدد اليوم",
        WEEK_REGISTERED_USERS: "مسجلين جدد هذا الأسبوع",
        MONTH_REGISTERED_USERS: "مسجلين جدد هذا الشهر",
        INFO: "معلومات",
        SUB_CATEGORIES: "الفئات الفرعية",
        SUB_CATEGORIES_LIST: "قائمة الفئات الفرعية",
        LOGO: "الشعار",
        ARTICLES_LIST: "قائمة المقالات",
        BODY: "المحتوى",
        LAST_LOGIN: "آخر تسجيل دخول",
        SOCIAL_LINKS: "روابط التواصل ",
        TITLE: "العنوان",
        SOCIAL_LINKS_URL: "رابط الشبكات الاجتماعية",
        PREVIEW: "معاينة",
        NOTIFICATION_SENT_SUCCESS: "تم إرسال الإشعار بنجاح",
        NOTIFICATION_SENT_ERROR: "فشل في إرسال الإشعار",
        INVALID_USER_ID: "معرف المستخدم غير صحيح",
        MAKTABTI: "مكتبتي",
        DAILY_ARTICLES: "المقالات اليومية",
        MOST_VIEW_BOOKS: "الكتب الأكثر مشاهدة",
        MOST_VIEW_BOOKS_LIST: "قائمة الكتب الأكثر مشاهدة",
        AUTHOR_NAME: "اسم المؤلف",
        FILE_TYPE_ID: "نوع الملف",
        OPEN_LINK: "افتح الرابط",
        SOCIAL_LINKS_LIST: "قائمة الروابط الاجتماعية",
        URL: "الرابط",
        CLICKS: "النقرات",
        IMAGE: "الصورة",
        TITLEe: "المدير للتقسيط",
        LIST: "قائمة المدير للتقسيط",
        DEVICE_TYPE: "نوع الجهاز",
        TOTAL_AMOUNT: "إجمالي المبلغ",
        DOWN_PAYMENT: "المقدم",
        MOBILE_NUMBER: "رقم الموبيل",
        SELECTED_IMAGE_EDIT: "الصورة المختارة (عند التعديل)",
        BOOK_FILE: "ملف الكتاب",
        SUBMIT: "إرسال",
        USERS: "المستخدمون",
        USERS_LIST: "قائمة المستخدمين",
        SHOW: "عرض",
        ENTRIES: "المدخلات",
        SEARCH: "بحث",
        FAKE_USER: {
          NAME: "الاسم",
          EMAIL: "البريد الإلكتروني",
          MOBILE: "رقم الجوال",
          COUNTRY_ID: "الدولة",
          CITY_ID: "المدينة",
          PASSWORD: "كلمة المرور",
          PASSWORD_CONFIRMATION: "تأكيد كلمة المرور",
          IMAGE: "الصورة",
          SUBMIT: "إرسال",
        },
        ACTIONS: "الإجراءات",
        DELETE: "حذف",
        SELECTED_IMAGE: "الصورة المختارة",
        mostViewBook: "الكتب الأكثر مشاهدة",
        mainCategory: "الاقسام الرئيسية",
        subCategory: "الاقسام الفرعية",
        openScreens: "شاشات البداية",
        fakeUsers: "المستخدمين الوهمين",
        fakeUserss: " ح وهمية",
        dailyUser: "المستخدمين اليومين",
        HOME: "الرئيسية ",
        SEND_NOTIFICATION: "إرسال إشعار",
        SAMPLE: "عينة ",
        users: "المستخدمين",
        usersM: " المستخدمين الأكثر مشاهدة ",
        list: "القائمة",
        add: "إضافة",
        addS: " إضافة كتاب متجر",
        ads: "الإعلانات",
        counselors: "المستشارين",
        stores_offers: "عروض المتاجر",
        cancelation_reason: "سبب الإلغاء",
        ENTER_IMAGE_URL: "أدخل رابط الصورة",
        ENTER_FILE_URL: "أدخل رابط ملف الكتاب",
        companies: "الشركات",
        consulting: "الاستشارات",
        categories: "الفئات",
        services: "الخدمات",
        tags: "العلامات",
        articles: "المقالات",
        offers: "العروض",
        plantcards: "بطاقات النباتات",
        PHONE: "الهاتف",
        BIRTHDATE: "تاريخ الميلاد",
        TYPE: "النوع",
        BIO: "نبذة",
        UPDATED_AT: "تاريخ التحديث",
        Settings: "الإعدادات",
        ShowDetails: "عرض التفاصيل",
        Details: " التفاصيل",
        TermsAndConditions: "الشروط والأحكام",
        About: "حول",
        UNEXPECTED_ERROR: "حدث خطأ ما. حاول مرة أخرى.",
        Notifications: "الإشعارات",
        LIKES: "إعجابات",
        DISLIKES: "عدم إعجاب",
        COMMENTS: "تعليقات",
        ADD_ARTICLE: "إضافة مقالة",
        ARTICLE_TITLE: "عنوان المقالة",
        ARTICLE_BODY: "محتوى المقالة",
        PRIMARY_IMAGE: "الصورة الرئيسية",
        ADDITIONAL_IMAGES: "صور إضافية",
        ADDITIONAL_IMAGES_HINT: "يمكنك اختيار أكثر من صورة إضافية للمقالة",
        SAVE_ARTICLE: "حفظ المقالة",
        ARTICLE_SAVED: "تم حفظ المقالة بنجاح",
        SELECT_FAKE_USER: "اختر مستخدمًا وهميًا",
        FAKE_USER_LABEL: "المستخدم الوهمي",
        FILL_REQUIRED_FIELDS: "من فضلك أكمل الحقول المطلوبة",
        LIKE: "إعجاب",
        DISLIKE: "عدم إعجاب",
        WRITE_COMMENT: "اكتب تعليقًا",
        ADD_COMMENT: "إضافة تعليق",
        COMMENT_ADDED: "تمت إضافة التعليق بنجاح",
        COMMENT_DELETED: "تم حذف التعليق بنجاح",
        ARTICLE_REACTION_UPDATED: "تم تحديث التفاعل على المقالة بنجاح",
        Currencies: "العملات",
        Countries: "الدول",
        Cities: "المدن",
        plans: "الخطط",
        light: "الضوء",
        root: "الجذر",
        seed: "البذرة",
        soil: "التربة",
        stem: "الجذع",
        counselorspayment: "دفع المستشارين",
        OpenScreens: "الشاشات المفتوحة",
        GanatakCommunity: "مجتمع جانتاك",
        Paperform: "نموذج الورقة",
        Sizes: "الأحجام",
        Sliders: "المنزلقات",
        MONETIZATION: "التربّح",
        MONETIZATION_TERMS: "شروط التربّح",
        MONETIZATION_REQUESTS: "طلبات التربّح",
        REQUESTS: "الطلبات",
        DETAILS: "التفاصيل",
        USER: "المستخدم",
        REQUEST_STATUS: "حالة الطلب",
        ADMIN_NOTE: "ملاحظة الإدارة",
        SELECTED_STORIES: "القصص المختارة",
        VIEW: "عرض",
        PENDING: "قيد المراجعة",
        APPROVED: "تمت الموافقة",
        REJECTED: "مرفوض",
        DISABLED: "موقوف",
        ALL: "الكل",
        APPROVE: "موافقة",
        REJECT: "رفض",
        DISABLE: "إيقاف التربّح",
        DISABLE_HINT: "اكتب سبب الإيقاف في ملاحظة الإدارة ثم اضغط إيقاف",
        ENABLE: "إعادة التفعيل",
        ENABLE_HINT: "إعادة تفعيل التربح لهذا الطلب",
        STORIES: "القصص",
        PUBLISHED: "المنشورة",
        SUBMITTED_AT: "تاريخ الطلب",
        PICK_REQUEST: "اختر طلبًا لعرض التفاصيل",
        STATUS_pending: "بانتظار موافقة الإدارة",
        STATUS_approved: "تمت الموافقة",
        STATUS_rejected: "مرفوض",
        STATUS_disabled: "موقوف",
        TERMS_VERSIONS: "الإصدارات",
        NEW: "جديد",
        VERSION: "الإصدار",
        TITLE_AR: "العنوان (عربي)",
        TITLE_EN: "العنوان (إنجليزي)",
        CONTENT_AR: "المحتوى (عربي)",
        CONTENT_EN: "المحتوى (إنجليزي)",
        ACTIVE: "مفعّل",
        INACTIVE: "غير مفعّل",
        ACTIVATE: "تفعيل",
        TERMS_HINT: "هنا يمكنك تعديل شروط وأحكام التربح بالعربية والإنجليزية. سيتم عرض النسخة المفعّلة داخل التطبيق."

      },
      USERS_SECTION: "العملاء",
      USERS: {
        LIST: "قائمة المستخدمين",
        ADD: "إضافة مستخدم",
      },
      PRODUCTS: {
        Title: "المنتجات",
        LIST: "قائمة المنتجات",
        AT_HOME: "منتجات في المنزل",
      },
      COUNSELORS: {
        Title: "المستشارين",
        LIST: "قائمة الاستشاريين",
        ADD: "إضافة استشاري",
      },
      STORES: {
        Title: "المتاجر",
        LIST: "قائمة المتاجر",
        ADD: "إضافة متجر",
      },
      STORES_OFFERS: {
        Title: "عروض المتاجر",
        LIST: "قائمة العروض",
      },
      VOUCHER: {
        Title: "العروض الترويجية",
        TYPE: "أنواع العروض الترويجية",
        LIST: "قائمة العروض الترويجية",
      },
      cancelation_reasons: {
        Title: "سبب الالغاء",
        LIST: "قائمة أسباب الإلغاء",
        ADD: "إضافة سبب",
      },
      COMPANIES: {
        Title: "الشركات",
        LIST: "قائمة الشركات",
        ARCHIVED: "الشركات المؤرشفة",
        ADD: "إضافة شركة",
      },
      consulting: {
        Title: "الاستشارات",
        LIST: "قائمة الاستشارات",
      },
      SERVICES: {
        Title: "الخدمات",
        LIST: "قائمة الخدمات",
        ADD: "إضافة خدمة",
      },
      SECTION: {
        Title: "الاقسام",
        LIST: "قائمة الاقسام",
        TYPES: "انواع القسائم",
        ADD: "إضافة قسم",
      },
      ARTICLES: {
        Title: "المقالات",
        LIST: "قائمة المقالات",
        Plant_groups: "المجموعات النباتية",
        ADD: "إضافة ",
        various: "مقالات زراعية متنوعة",
      },
      TAGS: {
        Title: "التاجات",
        LIST: "قائمة التاجات",
        ADD: "إضافة علامة",
      },
      offers: {
        Title: "العروض",
        LIST: "قائمة العروض",
        ADD: "إضافة عروض",
      },
      reasone_canceled: {
        Title: "سبب الالغاء",
        LIST: "قائمة ",
        ADD: "إضافة",
      },

      PLANTCARDS: {
        TITLE: "بطاقات النباتات",
        LIST: "قائمة بطاقات النباتات",
        ADD: "إضافة بطاقة نبات",
        LEAVERSCOLOR: {
          TITLE: "ألوان أوراق النباتات",
          LIST: "قائمة ألوان أوراق النباتات",
          ADD: "إضافة لون لأوراق النباتات",
        },
        LEAVERSFORM: {
          TITLE: "أشكال أوراق النباتات",
          LIST: "قائمة أشكال أوراق النباتات",
          ADD: "إضافة شكل لأوراق النباتات",
        },
        FLOWERFORM: {
          TITLE: "أشكال الأزهار",
          LIST: "قائمة أشكال الأزهار",
          ADD: "إضافة شكل للأزهار",
        },
        FLOWERCOLOR: {
          TITLE: "ألوان الأزهار",
          LIST: "قائمة ألوان الأزهار",
          ADD: "إضافة لون للأزهار",
        },
        ENVIRONMENTLIGHT: {
          TITLE: "إضاءة البيئة",
          LIST: "قائمة إضاءة البيئة",
          ADD: "إضافة إضاءة بيئة",
        },
        ENVIRONMENTTEMP: {
          TITLE: "درجة حرارة البيئة",
          LIST: "قائمة درجات حرارة البيئة",
          ADD: "إضافة درجة حرارة بيئة",
        },
        ENVIRONMENHUMIDITY: {
          TITLE: "رطوبة البيئة",
          LIST: "قائمة رطوبة البيئة",
          ADD: "إضافة رطوبة بيئة",
        },
        REPRODUCTIONS: {
          TITLE: "التكاثر",
          LIST: "قائمة طرق التكاثر",
          ADD: "إضافة طريقة تكاثر",
        },
        PLANTCARDSOIL: {
          TITLE: "أنواع التربة",
          LIST: "قائمة أنواع التربة",
          ADD: "إضافة نوع تربة",
        },
      },
    },
  },
};
